<template>
  <nav>
    <navLink
      v-for="link in links"
      :key="link.name"
      :name="link.name"
      :links="links"
      :href="link.href"
      :id="link.id"
    />
  </nav>
</template>

<script>
/**
 * @fileoverview Common component for side navigation
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import navLink from "./nav-link";

export default {
  name: "SideNavigation",
  components: { navLink },
  props: {
    links: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
nav {
  background: $qvo-color-blue-100;
  padding: $qvo-spacing-24;
  &::v-deep {
    .button.v-btn:not(.v-btn--round).v-btn--text {
      width: 100%;
      border: unset;
      .v-btn__content {
        justify-content: space-between;
        width: 100%;
        text-transform: none;
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.5;
        .label {
          color: $qvo-color-grey-600;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
    .v-btn--active.button.v-btn--text {
      &::before {
        background: none;
      }
      .v-btn__content .label {
        color: $qvo-color-grey-900;
      }
    }
  }
}
</style>